import { render, staticRenderFns } from "./TDProductionAlerts.vue?vue&type=template&id=032b345a"
import script from "./TDProductionAlerts.vue?vue&type=script&lang=js"
export * from "./TDProductionAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports